import Vue from 'vue';
import supplierTransformer from './../../transformers/supplier';

const success = (resolve, response) => {
  resolve(supplierTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(supplierTransformer.fetch(errors));
};

export default supplier => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/suppliers', supplier)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/supplier/store.js